// @flow
const riskfied = (() => {
    return (store: any) => (next: Function) => (action: any) => {
        switch (action.type) {
            case '@@router/LOCATION_CHANGE':
                if (typeof window !== 'undefined' && window.RISKX) {
                    const { pathname, search } = action.payload;
                    window.RISKX.go(`${pathname}${search}`);
                }
                break;
            default:
                break;
        }
        return next(action);
    };
})();

export default riskfied;
